import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMatchDownMd } from "Common/Hooks";
import { IConversationTitle, IUIElementState } from "Common/Interfaces";

export const useHome = () => {
  const { matchDownMd } = useMatchDownMd();
  const location = useLocation();

  const [drawer, setDrawer] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const [isInsideCollapsed, setIsInsideCollapsed] = useState<boolean>(false);

  const [uiElementState, setUIElementState] = useState<IUIElementState<IConversationTitle>>({
    anchorEl: null,
    activeElement: null,
    dataRow: null,
  });

  const handleCloseUIElement = () => {
    setUIElementState((prev) => ({
      ...prev,
      element: null,
      message: "",
      activeElement: null,
    }));
  };

  useEffect(() => {
    if (matchDownMd) {
      setDrawer(false);
      setIsCollapsed(true);
    }
  }, [matchDownMd, location]);

  return {
    matchDownMd,
    drawer,
    setDrawer,
    isCollapsed,
    setIsCollapsed,
    isInsideCollapsed,
    setIsInsideCollapsed,
    uiElementState,
    handleCloseUIElement,
    setUIElementState,
  };
};
